// Region name -> file slug for the static data files in
// public/regions-data/ (same folding rules as the climate PNG slugs).
// Shared by the build-time generator (scripts/build_region_data.mjs)
// and the client's static-first fetch, so the two can never drift.
export function regionSlug(name) {
  return String(name).toLowerCase()
    .replace(/\s+/g, '-').replace(/\//g, '-')
    .replace(/ü/g, 'ue').replace(/ö/g, 'oe').replace(/ä/g, 'ae').replace(/ß/g, 'ss');
}
